import { Link } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Switch } from '@/components/ui/switch';
import { GraduationCap, ArrowRight, Users } from 'lucide-react';
import { FadeIn } from '@/components/motion';
import { useCertificationInterest } from '@/lib/hooks/use-certification-interest';

export function CertificationProfileBanner() {
  const { isInterested, isLoading, updateInterest, isUpdating } = useCertificationInterest();

  if (isLoading) return null;

  return (
    <FadeIn>
      <Card className={`mb-6 border-2 ${isInterested ? 'border-green-200 bg-gradient-to-r from-green-50 to-emerald-50' : 'border-color-4/30 bg-gradient-to-r from-color-4/5 via-purple-50/30 to-blue-50/20'}`}>
        <CardContent className="py-5 px-6">
          <div className="flex items-center justify-between gap-4">
            <div className="flex items-center gap-4">
              <div className={`h-12 w-12 rounded-xl flex items-center justify-center ${isInterested ? 'bg-green-100' : 'bg-color-4/10'}`}>
                <GraduationCap className={`h-6 w-6 ${isInterested ? 'text-green-600' : 'text-color-4'}`} />
              </div>
              <div>
                <h3 className="font-bold text-base">
                  {isInterested ? 'You\'re Open to Certification Cohorts!' : 'Get Claude Certified with a Team'}
                </h3>
                <p className="text-sm text-muted-foreground mt-0.5">
                  {isInterested
                    ? 'Other Geniuses can find you in the Certification Hub. Browse partners and join a cohort.'
                    : 'The Claude Certified Architect program requires teams of 10. Opt in to find your team.'}
                </p>
              </div>
            </div>
            <div className="flex items-center gap-3 flex-shrink-0">
              <Switch
                checked={isInterested}
                onCheckedChange={(checked) => updateInterest({ is_interested: checked })}
                disabled={isUpdating}
              />
              <Link to="/genius/certification">
                <Button size="sm" variant={isInterested ? 'default' : 'outline'} className="gap-1.5">
                  {isInterested ? <Users className="h-3.5 w-3.5" /> : <ArrowRight className="h-3.5 w-3.5" />}
                  {isInterested ? 'Find Partners' : 'Learn More'}
                </Button>
              </Link>
            </div>
          </div>
        </CardContent>
      </Card>
    </FadeIn>
  );
}
